module.exports = __webpack_public_path__ + "static/bg.e20ca771.png";